import { LABS_SETTINGS } from '../../constants';

/**
 * Инициализация обработки клика на баннере "создать лабораторию" в каталоге кофе
 * По клику пишем в localStorage флаг, о том что юзер кликнул на этот баннер
 * Дальше перенаправляем его после успешного логина/регистрации
 * на страницу лабораторий в соответствующих компонентах
 */
export function initClickNoLabBanner() {
    const banner = $('.js-no-lab-banner');
    const mobileBanner = $('.js-no-lab-banner-mobile');
    const mobileBannerTitle = $('.js-banner-title', mobileBanner);
    localStorage.removeItem(LABS_SETTINGS.openLabsAfterLoginLSKey);

    banner.on('click', () => {
        localStorage.setItem(LABS_SETTINGS.openLabsAfterLoginLSKey, '1');
    });

    $('#loginModal').on('hide.bs.modal', () => {
        localStorage.removeItem(LABS_SETTINGS.openLabsAfterLoginLSKey);
    });

    mobileBannerTitle.on('click', () => {
        mobileBanner.toggleClass('no-lab-banner--open');
    });
}
